<p-dialog
  id="modal-register-project"
  name="modal-register-project"
  [header]="(editMode ? 'project.register.editHeader' : 'project.register.createHeader') | transloco"
  [modal]="true"
  [draggable]="false"
  [(visible)]="showDialog"
  (onHide)="closeModal()"
  [dismissableMask]="true"
>
  <div class="modal-content">
    <form [formGroup]="form">
      <!-- ══════════ STEPPER CLICÁVEL ══════════ -->
      <nav class="wz-steps" role="tablist" [attr.aria-label]="'project.register.header' | transloco">
        <button
          type="button"
          class="wz-step"
          *ngFor="let step of steps; let i = index"
          [class.active]="activeStep === i"
          [class.done]="activeStep !== i && isStepDone(i)"
          [class.error]="activeStep !== i && stepHasError(i)"
          role="tab"
          [attr.aria-current]="activeStep === i ? 'step' : null"
          (click)="goToStep(i)"
        >
          <span class="wz-step__line" *ngIf="i < steps.length - 1"></span>
          <span class="wz-step__num">
            <i class="pi pi-check" *ngIf="activeStep !== i && isStepDone(i)"></i>
            <i class="pi pi-exclamation-triangle" *ngIf="activeStep !== i && stepHasError(i)"></i>
            <ng-container *ngIf="activeStep === i || (!isStepDone(i) && !stepHasError(i))">{{ i + 1 }}</ng-container>
          </span>
          <span class="wz-step__lbl">{{ step.label }}</span>
        </button>
      </nav>

      <!-- ══════════ PASSO 1 — DADOS BÁSICOS ══════════ -->
      <div class="wz-panel" *ngIf="currentStep?.key === 'basic'">
        <div class="wz-sec-header">
          <span class="wz-sec-title">{{ "project.register.basicData" | transloco }}</span>
          <span class="wz-sec-line"></span>
        </div>

        <div class="wz-grid">
          <div class="wz-field">
            <label for="name">{{ "project.register.name" | transloco }} <span class="req">*</span></label>
            <input
              type="text"
              id="name"
              name="name"
              formControlName="name"
              maxlength="80"
              placeholder="{{ 'project.register.name' | transloco }}"
              pInputText
            />
          </div>

          <div class="wz-field">
            <label for="application">{{ "project.register.application" | transloco }} <span class="req">*</span></label>
            <p-dropdown
              inputId="application"
              [options]="applicationOptions"
              formControlName="application"
              name="application"
              optionLabel="name"
              placeholder="{{ 'project.register.application' | transloco }}"
              emptyMessage="{{ 'noResult' | transloco }}"
            />
          </div>

          <div class="wz-field">
            <label for="sharingProjectType">{{ "project.register.sharingProjectType" | transloco }} <span class="req">*</span></label>
            <p-dropdown
              inputId="sharingProjectType"
              name="sharingProjectType"
              [options]="sharingProjectTypeOptions"
              formControlName="sharingProjectType"
              optionLabel="name"
              placeholder="{{ 'project.register.sharingProjectType' | transloco }}"
              emptyMessage="{{ 'noResult' | transloco }}"
            />
          </div>

          <div class="wz-field">
            <label for="manufacturer">{{ "project.register.manufacturer" | transloco }}</label>
            <p-autoComplete
              inputId="manufacturer"
              name="manufacturer"
              formControlName="manufacturer"
              [(ngModel)]="selectedCarManufacturer"
              [suggestions]="filtredManufacturer"
              (completeMethod)="filterManufacturer($event)"
              (onSelect)="getCarModels($event.value.name, $event.value.code)"
              optionLabel="name"
              [dropdown]="true"
              placeholder="{{ 'project.register.manufacturer' | transloco }}"
              emptyMessage="{{ 'noResult' | transloco }}"
            />
          </div>

          <div class="wz-field">
            <label for="model">{{ "project.register.model" | transloco }}</label>
            <p-autoComplete
              inputId="model"
              name="model"
              formControlName="model"
              optionLabel="name"
              [(ngModel)]="selectedCarModel"
              [suggestions]="filtredModel"
              (completeMethod)="filterModel($event)"
              [dropdown]="true"
              placeholder="{{ 'project.register.model' | transloco }}"
              emptyMessage="{{ 'noResult' | transloco }}"
            />
          </div>

          <div class="wz-field">
            <label for="yearDate">{{ "project.register.yearDate" | transloco }}</label>
            <p-calendar
              inputId="yearDate"
              name="yearDate"
              formControlName="yearDate"
              placeholder="{{ 'project.register.yearDate' | transloco }}"
              view="year"
              dateFormat="yy"
            />
          </div>

          <div class="wz-field wz-field--full">
            <label for="tags">{{ "project.register.tags" | transloco }}</label>
            <p-chips
              inputId="tags"
              name="tags"
              placeholder="{{ 'project.register.tags' | transloco }}"
              formControlName="tags"
              separator=","
            />
            <small class="wz-hint">{{ "project.register.tagsLabel" | transloco }}</small>
          </div>

          <div class="wz-field wz-field--full">
            <label for="detail">{{ "project.register.detail" | transloco }}</label>
            <textarea
              id="detail"
              name="detail"
              rows="4"
              maxlength="500"
              placeholder="{{ 'project.register.detail' | transloco }}"
              pInputTextarea
              formControlName="detail"
            ></textarea>
          </div>

          <div class="wz-field wz-field--full wz-switch">
            <p-inputSwitch inputId="favorite" formControlName="favorite" />
            <label for="favorite" class="wz-switch__lbl">{{ "project.register.favorite" | transloco }}</label>
          </div>
        </div>
      </div>

      <!-- ══════════ PASSO 2 — EQUIPAMENTOS ══════════ -->
      <div class="wz-panel" *ngIf="currentStep?.key === 'equipment'">
        <div class="wz-sec-header">
          <span class="wz-sec-title">{{ "project.register.linkEquipment" | transloco }}</span>
          <span class="wz-sec-line"></span>
          <div class="wz-equip-actions">
            <button type="button" class="wz-add-btn" (click)="addGenericEquipment('vcu')">
              <i class="pi pi-plus"></i> {{ "project.register.newVcu" | transloco }}
            </button>
            <button type="button" class="wz-add-btn" (click)="addGenericEquipment('equipment')">
              <i class="pi pi-plus"></i> {{ "project.register.newEquipment" | transloco }}
            </button>
          </div>
        </div>

        <div class="wz-empty" *ngIf="getGenericEquipments().length === 0">
          {{ "project.register.equipmentEmpty" | transloco }}
        </div>

        <div class="wz-equip-list">
          <ng-container *ngFor="let generic of getGenericEquipments(); let i = index" formArrayName="genericEquipments">
            <ng-container [formGroupName]="i">
              <div class="wz-equip-row" *ngIf="getGenericType(generic.value) === 'vcu'">
                <div class="wz-field">
                  <label>VCU</label>
                  <p-dropdown
                    name="vcus"
                    [options]="vcusOptions"
                    formControlName="vcu"
                    optionLabel="name"
                    appendTo="body"
                    placeholder="-"
                    emptyMessage="{{ 'project.register.emptyMessageVcu' | transloco }}"
                  />
                </div>
                <button type="button" class="wz-remove" (click)="removeGenericEquipment(i)" [attr.aria-label]="'project.register.upload.remove' | transloco">
                  <i class="pi pi-trash"></i>
                </button>
              </div>

              <div class="wz-equip-row" *ngIf="getGenericType(generic.value) === 'equipment'">
                <div class="wz-field">
                  <label>{{ "project.register.category" | transloco }}</label>
                  <p-dropdown
                    name="categories"
                    [options]="categoriesOptions"
                    formControlName="category"
                    optionLabel="name"
                    appendTo="body"
                    (onChange)="FindEquipments($event.value.id, i)"
                    placeholder="-"
                    emptyMessage="{{ 'noResult' | transloco }}"
                  />
                </div>
                <div class="wz-field">
                  <label>{{ "project.register.product" | transloco }}</label>
                  <p-dropdown
                    name="products"
                    [options]="productsOptions[i]"
                    formControlName="product"
                    optionLabel="name"
                    appendTo="body"
                    placeholder="-"
                    emptyMessage="{{ 'project.register.emptyMessageProduct' | transloco }}"
                  />
                </div>
                <button type="button" class="wz-remove" (click)="removeGenericEquipment(i)" [attr.aria-label]="'project.register.upload.remove' | transloco">
                  <i class="pi pi-trash"></i>
                </button>
              </div>
            </ng-container>
          </ng-container>
        </div>
      </div>

      <!-- ══════════ PASSO 3 — IMAGENS ══════════ -->
      <div class="wz-panel" *ngIf="currentStep?.key === 'images'">
        <div class="wz-sec-header">
          <span class="wz-sec-title">{{ currentStep?.label }}</span>
          <span class="wz-sec-line"></span>
        </div>

        <label
          class="wz-dropzone"
          [class.dragging]="isDragging"
          (dragover)="onDragOver($event)"
          (dragleave)="onDragLeave($event)"
          (drop)="onDrop($event)"
        >
          <i class="pi pi-cloud-upload"></i>
          <span class="wz-dropzone__hint">{{ "project.register.upload.dropHint" | transloco }}</span>
          <input
            #fileInput
            type="file"
            multiple
            accept=".jpg,.jpeg,.png,.webp,image/jpeg,image/png,image/webp"
            (change)="onSelectFile($event)"
            hidden
          />
        </label>

        <div class="wz-gallery" *ngIf="project && project.images.length">
          <ng-container *ngFor="let image of project.images; let i = index">
            <div class="wz-gallery__item" *ngIf="!image.name.includes('thumb')">
              <img [src]="image.href" [alt]="image.name" class="wz-gallery__img" />
              <button type="button" class="wz-img-btn wz-img-btn--delete" (click)="removeImage(image)" [attr.aria-label]="'project.register.upload.remove' | transloco">
                <i class="pi pi-trash"></i>
              </button>
              <button
                type="button"
                class="wz-img-btn wz-img-btn--star"
                [class.active]="image.primary"
                (click)="setPrimaryImage(image)"
                [attr.aria-label]="'project.register.upload.primaryPhoto' | transloco"
              >
                <i class="pi pi-star-fill"></i>
              </button>
            </div>
          </ng-container>
        </div>
      </div>

      <!-- ══════════ PASSO 4 — COMPARTILHAR (somente criar) ══════════ -->
      <div class="wz-panel" *ngIf="currentStep?.key === 'share'">
        <div class="wz-sec-header">
          <span class="wz-sec-title">{{ "project.register.shareLabel" | transloco }}</span>
          <span class="wz-sec-line"></span>
        </div>

        <div class="wz-share-add">
          <div class="wz-field">
            <label for="email">{{ "project.register.email" | transloco }}</label>
            <input
              type="email"
              id="email"
              name="email"
              formControlName="email"
              placeholder="{{ 'project.register.email' | transloco }}"
              pInputText
            />
          </div>
          <p-button
            label="{{ 'project.register.addBtn' | transloco }}"
            severity="danger"
            [raised]="true"
            (click)="addShare()"
          />
        </div>

        <p-table
          *ngIf="project"
          #dtShare
          [value]="project.sharedWith"
          dataKey="id"
          [loading]="loadingShare"
          [tableStyle]="{ 'min-width': '100%' }"
        >
          <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="email" style="width: 55%">
                {{ "project.detail.tableShare.email" | transloco }}
                <p-sortIcon field="email" />
              </th>
              <th pSortableColumn="date" style="width: 30%">
                {{ "project.detail.tableShare.date" | transloco }}
                <p-sortIcon field="date" />
              </th>
              <th style="width: 15%"></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-share let-ri="rowIndex">
            <tr>
              <td>{{ share.email }}</td>
              <td>{{ share.date }}</td>
              <td>
                <p-button [rounded]="true" [text]="true" icon="pi pi-times" (click)="removeShare(ri)" />
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="3">{{ "project.detail.tableShare.noFound" | transloco }}.</td>
            </tr>
          </ng-template>
        </p-table>
      </div>

      <!-- ══════════ RODAPÉ ══════════ -->
      <div class="wz-footer">
        <span class="wz-progress">{{ "project.register.stepOf" | transloco: { "0": activeStep + 1, "1": steps.length } }}</span>
        <div class="wz-foot-btns">
          <p-button
            *ngIf="!isFirstStep"
            severity="secondary"
            [raised]="true"
            label="{{ 'project.register.backBtn' | transloco }}"
            (click)="prev()"
          />
          <p-button
            *ngIf="!isLastStep"
            severity="danger"
            [raised]="true"
            label="{{ 'project.register.nextBtn' | transloco }}"
            (click)="next()"
            [loading]="creatingProject"
            [disabled]="creatingProject"
          />
          <p-button
            *ngIf="isLastStep"
            severity="danger"
            [raised]="true"
            label="{{ 'project.register.finishBtn' | transloco }}"
            (click)="submit()"
            [loading]="isClicked || loadingUpload"
            [disabled]="loadingUpload || !allRequiredValid"
          />
        </div>
      </div>
    </form>
  </div>
</p-dialog>
<p-toast key="toastRegisterProject" />
